// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".report-container{width:100%;height:100%;background-color:#e0e0e0;z-index:99;position:fixed;top:0;left:0}", ""]);
// Exports
module.exports = exports;
